export default __webpack_public_path__ + "static/france_euromillions-26ef71fc4060e0342768a4eb1375fa72.png";